<script lang="ts" setup>
const props = defineProps({
  data: Object as any
})
</script>

<template>
  <div class="category">
    <div class="category__pic square__pic">
      <nuxt-link :to="props.data.link">
        <Nimg :src="props.data.image" />
      </nuxt-link>
    </div>
    <div class="category__title" v-html="props.data.title"></div>
    <template v-if="props.data.icon !== 'icon-line'">
      <nuxt-link :to="props.data.link" class="category__arrow">
        <svg-icon name="icon-arrow-right3" :style="{ transform: `rotate(${props.data.rotate}deg)` }" />
      </nuxt-link>
    </template>
    <template v-else>
      <nuxt-link :to="props.data.link" class="category__line">
        <svg-icon :name="props.data.icon" />
      </nuxt-link>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.category {
  position: relative;

  &:hover {
    .category {
      &__pic {
        &::before {
          opacity: 1;
        }

        img {
          opacity: 0.5;
        }
      }

      &__title {
        color: $color-white-1;
      }

      &__arrow {
        color: $color-white-1;
        border-color: $color-white-1;
      }
    }
  }

  &__title {
    position: absolute;
    left: toRem(24);
    top: toRem(24);
    font-size: toRem(22);
    transition: all 0.6s cubic-bezier(0.87, 0, 0.13, 1);

    @include max-media(480) {
      left: toRem(12);
      bottom: toRem(12);
      font-size: toRem(16);
    }
  }

  &__pic {
    background-color: $color-white-1;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: $color-black-1;
      opacity: 0;
      transition: all 0.6s cubic-bezier(0.87, 0, 0.13, 1);
    }

    img {
      opacity: 0;
      transition: all 0.6s cubic-bezier(0.87, 0, 0.13, 1);
    }
  }

  &__arrow {
    position: absolute;
    left: toRem(24);
    bottom: toRem(24);
    display: flex;
    align-items: center;
    justify-content: center;
    width: toRem(40);
    height: toRem(40);
    border: 1px solid $color-gray-line;
    border-radius: 50%;
    color: $color-brand-3;
    transition: all 0.6s cubic-bezier(0.87, 0, 0.13, 1);

    @include max-media(480) {
      left: toRem(12);
      bottom: toRem(12);
      width: toRem(33);
      height: toRem(33);
    }

    svg {
      width: toRem(16);
      height: toRem(16);
    }
  }

  &__line {
    position: absolute;
    left: toRem(24);
    bottom: toRem(24);
    display: flex;
    align-items: center;
    justify-content: center;
    width: toRem(36);
    height: toRem(36);
    color: $color-brand-3;

    svg {
      display: block;
      width: 100%;
    }
  }
}
</style>
